import { ComponentSettingsKpiChartMeasureField, getKpiChartMeasureFieldDisplayLabel } from '@report-content';
import { AssocArray } from 'tools/types';

export interface IKeepFirstRowPerDateResult {
    rows: Array<AssocArray<string>>;
    // Labels of the non-aggregated measures, set only when rows were dropped
    nonAggregatedMeasures: Array<string>;
}

// A measure without aggregation is grouped by on the backend, so one date can come back as several
// rows and every other measure is split across them. The chart keeps one point per date.
export function keepFirstRowPerDate(
    rows: Array<AssocArray<string>>,
    measureFields: Array<ComponentSettingsKpiChartMeasureField>,
    xField: string,
): IKeepFirstRowPerDateResult {
    const nonAggregated = measureFields.filter((f) => !f.aggregation_function || f.aggregation_function == 'None');
    if (!nonAggregated.length) {
        return { rows, nonAggregatedMeasures: [] };
    }

    const seenDates = new Set<string>();
    const result = rows.filter((row) => {
        const date = row[xField];
        if (date == null) {
            return true;
        }
        if (seenDates.has(String(date))) {
            return false;
        }
        seenDates.add(String(date));
        return true;
    });

    return {
        rows: result,
        nonAggregatedMeasures:
            result.length < rows.length ? nonAggregated.map((f) => getKpiChartMeasureFieldDisplayLabel(f)) : [],
    };
}
